import { Box, Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Typography, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

// import AnalysticsIcon from "../../icons/AnalysticsIcon";
import HomeIcon from "../../icons/HomeIcon";
import PeopleIcon from "../../icons/PeopleIcon";
import UploadIcon from "../../icons/UploadIcon";



const menuItems = [
    {
        pageLabel: "Home",
        icon: <HomeIcon />,
        path: "/leads-management",
        topBarContent: "Manage and track all your leads"
    },
    {
        pageLabel: "All Leads",
        icon: <PeopleIcon />,
        path: "/leads-management/all-leads",
        topBarContent: "Overview of your lead pipeline and performance"
    },
    // {
    //     pageLabel: "Social Insights",
    //     icon: <AnalysticsIcon />,
    //     path: "/leads-management/social-insights",
    //     topBarContent: "Manage and track all your leads"
    // },
    {
        pageLabel: "Import Leads",
        icon: <UploadIcon />,
        path: "/leads-management/import-leads",
        topBarContent: "Import Leads"
    },
]

const LeadsManagementSideMenu = () => {
    const location = useLocation();
    const { t } = useTranslation();

    const isActive = (path: string) => {
        if (path === "/leads-management") {
            // For dashboard, match exact path or root path
            return location.pathname === path || location.pathname === "/leads-management/";
        }
        return location.pathname === path;
    };


    return (
        <Box sx={{ height: "100%", width: "300px", background: "#FAE4D3"}}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", marginLeft: "32px", gap: 2, paddingTop: "32px", paddingBottom: "24px" }}>
                <Typography component="h3">{t("platform.SideMenu_topDescription")}</Typography>
                <Typography component="div" sx={{ color: "#5D6E69", lineHeight: "24px" }}>{t("platform.SideMenu_topContent")}</Typography>
            </Box>
            <Divider sx={{ borderColor: "#F3D2B8", marginBottom: "32px" }} />
            <MenuList sx={{ height: "100vh" }}>
                {menuItems.map((item) => {
                    const active = isActive(item.path);
                    return (
                        <MenuItem
                            key={item.pageLabel}
                            component={Link}
                            to={item.path}
                            selected={active}
                            // onClick={() => setMenuDescription({ title: item.pageLabel, content: item.topBarContent })}
                            sx={{
                                borderRadius: "8px",
                                margin: "4px 16px",
                                padding: "12px",
                                color: "black",
                                "& .MuiListItemIcon-root": {
                                    color: "black",
                                },
                                "&.Mui-selected": {
                                    backgroundColor: "#E87722",
                                    color: "white",
                                    fontWeight: 700,
                                    "& .MuiListItemIcon-root": {
                                        color: "white",
                                    },
                                    "&:hover": {
                                        backgroundColor: "#E87722",
                                    },
                                },
                            }}
                        >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText>{item.pageLabel}</ListItemText>
                        </MenuItem>
                    )
                })}

            </MenuList>
        </Box>
    )
}


export default LeadsManagementSideMenu;